module.exports = __webpack_public_path__ + "img/the-testaments.d5e3652b.png";